import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { openingBalanceColumns } from "../../../utils/Level/utils";
// import { NavBar } from 'app/components/NavBar';
import { CssBaseline, Paper, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import OpeningForm from "../../../components/Accounts/OpeningBalanceForm";
import { updateAllLevels } from "../../../store/action";
import { level3Data } from "../../../store/reducer/levelSlice";
import { tableCellStyle } from "../../../styles";
import { updateLevel3 } from "../../../utils/endPoints";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";

const OpeningBalance = () => {
  const dispatch = useAppDispatch();
  const classes = tableCellStyle();
  const OpeningBalanceData = useAppSelector(level3Data);
  console.log(OpeningBalanceData);
  const [showEntryForm, setShowEntryForm] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [type, setType] = useState("BRV");

  let filteredData = OpeningBalanceData.map((item) => {
    let amount = item.amount ? parseInt(item.amount).toLocaleString() : 0;
    return {
      fullcode: item.fullcode,
      type: item.type,
      transactionType: item?.transactionType ? item.transactionType : "Debit",
      amount: amount,
      Discription: item.Discription
    };
  });

  function addNewVoucher(event, params) {
    setSelectedData(params.row);
    setShowEntryForm(true);
  }
  async function firebaseUpdate(data) {
    setShowEntryForm(false);
    const res = await updateLevel3(data.fullcode, data);
    console.log(res);
    if (res?.msg.endsWith("successfully")) {
      toast.success(res.msg);
      updateAllLevels(dispatch);
    } else {
      toast.error("Failed to Update!");
    }
  }

  return (
    <Paper>
      <CssBaseline />
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "1rem",
            justifyContent: "center",
            // backgroundColor: '#5CDB95',
          }}
        >
          <ToastContainer
            position="bottom-center"
            autoClose={2000}
            hideProgressBar={true}
            closeOnClick={true}
            progress={undefined}
          />
          {showEntryForm ? (
            <OpeningForm
              okCallback={(data) => {
                console.log(data);
                setShowEntryForm(false);
                firebaseUpdate(data);
              }}
              cancelCallback={() => {
                setShowEntryForm(false);
              }}
              level3Codes={OpeningBalanceData}
              level3CodesFiltered={OpeningBalanceData}
              vtype={type}
              visible={showEntryForm}
              row={selectedData}
            ></OpeningForm>
          ) : (
            <></>
          )}
          {/* <NavBar /> */}
          <Typography variant="h5" component="h2" gutterBottom>
            Opening Balance
          </Typography>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "95%",
              height: "80vh",
              // backgroundColor: '#EDF5E1',
            }}
            className={classes.root}
          >
            <DataGrid
              headerHeight={70}
              rowHeight={25}
              style={{ width: "100%" }}
              onCellDoubleClick={(params, event) => {
                console.log("Cell Clicked... ", params, event);
                addNewVoucher(event, params);
              }}
              rows={filteredData?.map((item, index) => {
                return {
                  id: index + 1,
                  ...item,
                };
              })}
              columns={openingBalanceColumns}
              pageSize={25}
              disableColumnMenu
            />
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default OpeningBalance;
